import { ExpandMore, Info } from '@mui/icons-material';
import { Accordion, AccordionDetails, AccordionSummary, Stack, Typography } from '@mui/material';
import { BettingSlip } from '../../@types/api';
import { getBettingSlipAcceptStatusColor } from '../../utils';

type CollapsibleAuthResultsProps = Pick<BettingSlip, 'authResults' | 'operator'>;

const CollapsibleAuthResults = ({ authResults, operator }: CollapsibleAuthResultsProps) => {
  const noResults = authResults?.length === 0;

  return (
    <Accordion disabled={noResults}>
      <AccordionSummary
        sx={{ backgroundColor: 'background.lighter', '&.Mui-disabled': { opacity: 1 } }}
        expandIcon={noResults ? null : <ExpandMore />}
      >
        <Typography variant='h5'>
          Ticket handling: {operator?.fullName ? `Manual - ${operator?.fullName}` : 'Auto'}
        </Typography>
      </AccordionSummary>
      <AccordionDetails sx={{ backgroundColor: 'background.lighter' }}>
        {authResults?.map((result) => (
          <Stack
            direction='row'
            spacing={1}
            key={result.entityId}
            sx={{
              alignItems: 'center',
              py: 0.5,
            }}
          >
            <Info sx={{ color: getBettingSlipAcceptStatusColor(result.status) }} />
            <Typography
              variant='body3'
              sx={{
                fontWeight: 500,
              }}
            >
              {result.adminMessage}
            </Typography>
          </Stack>
        ))}
      </AccordionDetails>
    </Accordion>
  );
};

export default CollapsibleAuthResults;
